/*
 * Engraving cart guard — each engraving fee line (_engraving_role: fee) must match
 * the quantity of the watch line that shares its _engraving_id, or be removed.
 */
(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let running = false;

  async function reconcile() {
    if (running) return;
    running = true;
    try {
      const cart = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const watchQuantities = {};
      cart.items.forEach((item) => {
        const props = item.properties || {};
        if (props._engraving_id && props._engraving_role !== 'fee') {
          watchQuantities[props._engraving_id] = (watchQuantities[props._engraving_id] || 0) + item.quantity;
        }
      });

      const updates = {};
      cart.items.forEach((item) => {
        const props = item.properties || {};
        if (props._engraving_role !== 'fee') return;
        const wanted = watchQuantities[props._engraving_id] || 0;
        if (item.quantity !== wanted) updates[item.key] = wanted;
      });
      if (!Object.keys(updates).length) return;

      const drawer = document.querySelector('cart-drawer');
      const result = await fetch(`${ROOT}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          sections: drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());

      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      } else if (drawer && result.sections && drawer.renderContents) {
        drawer.renderContents(result);
      }
    } catch (error) {
      console.warn('[engraving] cart check failed', error);
    } finally {
      running = false;
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source !== 'engraving-studio') reconcile();
    });
  }
  if (/\/cart\/?$/.test(window.location.pathname)) reconcile();
})();
